export default __webpack_public_path__ + "static/media/mPants_1_c2.c65a6487.jpeg";